import React from 'react';
import { Page } from '@shopify/polaris';
import ChatboxCustomizationCard from './ChatboxCustomizationCard';

export default function Chatbox() {
  return (
    <Page title="Chatbot Customization">
      <ChatboxCustomizationCard />
    </Page>
  );
}
